import { render } from "./RecoveryPassword.vue?vue&type=template&id=74ff7034"
import script from "./RecoveryPassword.vue?vue&type=script&lang=js"
export * from "./RecoveryPassword.vue?vue&type=script&lang=js"

import exportComponent from "/home/gustavo/Documents/frontend-ivv/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__